import { Tabs, TabsContent } from "../../@/components/ui/tabs";
import React from "react";
import { CalendarDateRangePicker } from "./analyticsComponents/AnalyticsCalenderPickerComponent";
import AnalyticsCardSection from "./analyticsComponents/AnalyticsCardSection";

export default function MainAnalyticComponent() {
  
  return (
    <>
      <div className="hidden flex-col md:flex w-[100vw]">
        <div className="flex-1 space-y-4 p-6 pt-6 ">
          <div className="flex items-center justify-end space-y-2">
            <div className="flex items-center space-x-2">
              <CalendarDateRangePicker />
            </div>
          </div>
          <Tabs defaultValue="overview" className="space-y-4">
            <TabsContent value="overview" className="space-y-4">
              <AnalyticsCardSection/>
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </>
  );
}
